import { render, staticRenderFns } from "./BuildSite.vue?vue&type=template&id=4463cf10&scoped=true&"
import script from "./BuildSite.vue?vue&type=script&lang=js&"
export * from "./BuildSite.vue?vue&type=script&lang=js&"
import style0 from "./BuildSite.vue?vue&type=style&index=0&id=4463cf10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4463cf10",
  null
  
)

component.options.__file = "BuildSite.vue"
export default component.exports